export default "__VITE_ASSET__CtRhLYIZ__"